export const API_BASE = window.location.hostname === 'localhost' 
  ? 'http://localhost:8080/api' 
  : 'https://bot.chartklar.de/api';
// Fri May 15 06:25:59 AM UTC 2026
